import pinBlack from './pin-black.svg';
import pinBlue from './pin-blue.svg';
import pinBrown from './pin-brown.svg';
import pinGray from './pin-gray.svg';
import pinGreen from './pin-green.svg';
import pinOrange from './pin-orange.svg';
import pinPurple from './pin-purple.svg';
import pinRed from './pin-red.svg';
import pinWhite from './pin-white.svg';
import pinYellow from './pin-yellow.svg';

const mapPinNameToSvg = {
    'red-pin-down': pinRed,
    'purple-pin': pinPurple,
    'blue-pin-down': pinBlue,
    'green-pin': pinGreen,
    'orange-pin': pinOrange,
    'yellow-pin': pinYellow,
    'brown-pin': pinBrown,
    'black-pin': pinBlack,
    'gray-pin': pinGray,
    'white-pin': pinWhite,
};

// The ones we want to display to users and use going forward
export default mapPinNameToSvg;

export {
    pinBlack,
    pinBlue,
    pinBrown,
    pinGray,
    pinGreen,
    pinOrange,
    pinPurple,
    pinRed,
    pinWhite,
    pinYellow,
};
